export const DEFAULT_AGE_QUOTA_CRITERIA = Object.freeze({
  MIN: 18,
  MAX: 99,
});
